import { render, staticRenderFns } from "./ModifyMember.vue?vue&type=template&id=067a7f51"
import script from "./ModifyMember.vue?vue&type=script&lang=js"
export * from "./ModifyMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports